export { default } from './Instagram';
